module.exports = __webpack_public_path__ + "3119d0672400fa338d6b148ba6bcf65b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cream_pixels_retina.png
 ** module id = 22
 ** module chunks = 0
 **/